export default __webpack_public_path__ + "static/people-1-7649dcaaeba788ad48c9dfd5bcdf46a3.png";